<template>
    <div v-if="hypoType !== 2" class="settings-panel">
        <div class="settings-panel__inner">
            <mds-section
                e2e="rebalance-section"
                :size="7"
                :collapsible="includeRebalance"
                bold
                ref="section"
                border="secondary"
                @mds-section-expanded="expandSection"
                @mds-section-closed="closeSection"
            >
                <template v-slot:mds-section-title>
                    <div>
                        <mds-icon v-if="includeRebalance && hasError && rebalanceType === 1" name="alert-fill" size="small" class="alert-icon"></mds-icon>
                        <span :class="{ 'rebalancing--disabled': !includeRebalance }">
                            {{ getUILabel(text) }}
                        </span>
                    </div>
                </template>
                <template v-slot:mds-section-actions>
                    <mds-switch e2e="rebalance-section-switch" v-model="includeRebalance" @change="toggleInclude">
                        {{ getUILabel("common_include") }}
                    </mds-switch>
                </template>
                <template v-slot:default>
                    <rebalancing-content :mwcId="getMwcIdForChild('content')" ref="content" @custom-rebalancing-error="handleError"> </rebalancing-content>
                </template>
            </mds-section>
            <rebalancing-summary v-if="!expanded && includeRebalance" :mwcId="getMwcIdForChild('summary')" @custom-rebalancing-error="handleError">
            </rebalancing-summary>
        </div>
    </div>
</template>

<script>
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import { mapState } from "vuex";
import * as types from "../store/mutation-types";
import RebalancingSummary from "./Summary";
import RebalancingContent from "./Rebalancing";
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import MdsIcon from "@mds/icon";
import MdsSection from "@mds/section";
import MdsSwitch from "@mds/switch";

export default {
    name: "rebalancing-panel",
    props: {
        text: String
    },
    components: {
        RebalancingSummary,
        RebalancingContent,
        MdsIcon,
        MdsSection,
        MdsSwitch
    },
    mixins: [HypoVueBaseMixin, MwcSharedMixin],
    data() {
        return {
            defaultConfig: {
                labels: this.$store.state.labels.labels
            },
            hasError: false,
            expanded: false
        };
    },
    computed: {
        ...mapState("rebalancing", ["rebalanceType", "frequencyType", "threshold", "rebalanceOptions", "frequencyOptions"]),
        hypoType() {
            return this.$store.getters["settings/getHypoType"];
        },
        includeRebalance: {
            get() {
                return this.$store.state.rebalancing.includeRebalance;
            },
            set(value) {
                this.$store.commit(`rebalancing/${types.SET_INCLUDE_REBALANCE}`, value);
            }
        }
    },
    methods: {
        expandSection() {
            this.expanded = true;
        },
        closeSection() {
            this.expanded = false;
        },
        toggleInclude(value, event) {
            this.$refs.section.toggle(event);
        },
        handleError(error) {
            this.hasError = !!error.payload;
            this.$emit("on-error", error);
        }
    },
    watch: {
        expanded: function(value) {
            if (value) {
                this.$store.dispatch("holdings/getSecurityLevelAssetAllocation", { fetch: this.$fetch }).then(() => {
                    this.$store.dispatch("rebalancing/updateRebalanceSecurities");
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~@mds/constants";
@import "@mds/icon/src/icon_mixins";

.rebalancing--disabled {
    color: #9b9b9b;
}

.alert-icon {
    @include mds-icon-color($mds-text-color-error);
    position: relative;
    top: 2px;
}
</style>
